import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zhTranslation from '../locales/zh/translation.json';
import enTranslation from '../locales/en/translation.json';
import { isEnglishSite } from '../config/site';

// 语言检测配置
const languageDetectorOptions = {
  // 检测顺序：cookie > navigator
  order: ['cookie', 'navigator'],
  // cookie 的 key
  lookupCookie: 'i18nextLng',
  // cookie 过期时间（分钟），设置为 1 年 = 365 * 24 * 60 分钟
  cookieMinutes: 365 * 24 * 60,
  // cookie 的选项
  cookieOptions: {
    path: '/',
    sameSite: 'lax' as const,
  },
  // 缓存用户选择的语言到 cookie
  caches: ['cookie'],
  // 检测到的语言映射
  convertDetectedLanguage: (lng: string) => {
    // 中文系语言映射到 zh
    if (lng.startsWith('zh')) {
      return 'zh';
    }
    // 英文系语言映射到 en
    if (lng.startsWith('en')) {
      return 'en';
    }
    // 其他语言默认使用英文
    return 'en';
  },
};

// Force English on postanything.net (English site)
const forcedLng = isEnglishSite() ? 'en' : undefined;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: {
        translation: zhTranslation,
      },
      en: {
        translation: enTranslation,
      },
    },
    lng: forcedLng, // Override when English site
    fallbackLng: 'en', // 默认语言为英文（如果检测失败）
    debug: false,
    interpolation: {
      escapeValue: false, // React 已经转义了
    },
    detection: languageDetectorOptions,
  });

export default i18n;
